const anchoredAlertStyles = {
  zIndex: 'inherit',
};

export default anchoredAlertStyles;
